module.exports = __webpack_public_path__ + "img/arrow-back.9e92633c.svg";